import $axios from "@/api";
import moment from "moment";

const state = () => ({
    datas: {
        mappingCheck: [],
        exportMars: {
            data: [],
            errors: []
        },
    },
    modal: {
        isOpen: false,
        backdrop: false,
        dismiss: true
    },
    filters:{
        exportMars: {
            id_company: '',
            ids_depo: [],
            start_date: moment(new Date).format("YYYY-MM-DD"),
            end_date: moment(new Date).format("YYYY-MM-DD"),
            last_sequence: 1,
        }
    }
})

const mutations = {
    SET_DATAS(state, payload){
        state.datas[payload.target] = payload.data
    },
    resetState(state) {
        const initialState = () => ({
            datas: {
                mappingCheck: [],
                exportMars: {
                    data: [],
                    errors: []
                },
            },
            modal: {
                isOpen: false,
                backdrop: false,
                dismiss: true
            },
            filters: {
                exportMars: {
                    id_company: '',
                    ids_depo: [],
                    start_date: moment(new Date).format("YYYY-MM-DD"),
                    end_date: moment(new Date).format("YYYY-MM-DD"),
                    last_sequence: 1,
                }
            }
        });
        Object.assign(state, initialState());
    },
    setModal(state){
        let condition = !state.modal.isOpen
        if(condition){
            state.modal.backdrop = condition 
            setTimeout(() => {
                state.modal.isOpen = condition;
            }, 100);
        }else{
            state.modal.isOpen = condition 
            setTimeout(() => {
                state.modal.backdrop = condition;
            }, 100);
        }
    }
}

const actions = {
    isModal({commit}){
        commit('setModal')
    },
    async getExportMars({state, commit}){
        try{
            const response = await $axios.get("external_app/mars/export",{params:state.filters.exportMars})
            commit("SET_DATAS",{target:'exportMars',data: response.data})
        }catch(err){    
            console.log(err)
        }
    },
    async getExportMarsIndofood({state, commit}){
        try{
            const response = await $axios.get("external_app/stt_enhanced/export/mars",{params:state.filters.exportMars})
            commit("SET_DATAS",{target:'exportMars',data: response.data})
        }catch(err){    
            console.log(err)
        }
    },
    resetState({commit}){
        commit('resetState')
    },
    async mappingCheck({commit}, payload){
        try{
            const response = await $axios.post("external_app/mars/mapping_check",payload)
            commit('SET_DATAS',{target:'mappingCheck',data: response.data.data})
            return response.data.headers
        }catch(err){    
            console.log(err)
        }
    },
    async mappingUpdate({commit}, payload){
        try{
            const response = await $axios.put("external_app/mars/mapping_update",payload)
            commit("SET_DATAS",{target:'mappingCheck',data: []})
            commit("SET_DATAS",{target:'exportMars',data: {data:[],errors: []}})
            return response.data.message
        }catch(err){    
            console.log(err)
        }
    }
}

export default {
    namespaced: true,   
    mutations,
    actions,
    state,
}

